module.exports = __webpack_public_path__ + "img/intro02.f111ba4b.png";